import * as server_php from './server.php'

export default [server_php]
